import { BadgeCheck } from "lucide-react";

// Purely visual — derived from the backend's confirmed Persona status. Not clickable, no tooltip, no link.
export default function VerifiedBadge({ show, size = "md", className = "" }) {
  if (!show) return null;
  const sm = size === "sm";
  return (
    <span
      data-testid="verified-badge"
      aria-label="Verified"
      className={`inline-flex items-center gap-1 align-middle select-none pointer-events-none text-sky-400 font-sans font-semibold tracking-normal ${sm ? "text-[11px]" : "text-sm"} ${className}`}
    >
      <BadgeCheck size={sm ? 13 : 17} className="fill-sky-500 text-white shrink-0" aria-hidden="true" />
      Verified
    </span>
  );
}
